import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetCompletedEvaluationDetailsUseCaseInterface } from 'domain/usecases';

export class RemoteGetCompletedEvaluationDetails
  implements GetCompletedEvaluationDetailsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetCompletedEvaluationDetailsUseCaseInterface.Params,
  ): Promise<GetCompletedEvaluationDetailsUseCaseInterface.Result> {
    const { surveyId } = params;

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${surveyId}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
